import { memo } from 'react';
import { Box, Typography, Grid, Container, Button } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

function HomeFooter({ colors, navigate, scrollToSection }) {
  return (
        <Box
          component="footer"
          sx={{
            py: { xs: 5, md: 6 },
            borderTop: `1px solid ${colors.border}`,
            bgcolor: colors.bgPaper,
          }}
        >
          <Container maxWidth="lg">
          <Grid container spacing={{ xs: 3, md: 4 }}>
            {/* Colonne Produit */}
            <Grid item xs={6} sm={3}>
              <Typography variant="subtitle2" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 1.5 }}>
                Produit
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Button size="small" onClick={() => scrollToSection('home-artists')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Pour les artistes</Button>
                <Button size="small" onClick={() => scrollToSection('home-features')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Comment ça marche</Button>
                <Button size="small" onClick={() => scrollToSection('home-pricing')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Tarifs</Button>
                <Button size="small" onClick={() => scrollToSection('home-faq')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>FAQ</Button>
              </Box>
            </Grid>

            {/* Colonne Ressources */}
            <Grid item xs={6} sm={3}>
              <Typography variant="subtitle2" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 1.5 }}>
                Ressources
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Button size="small" onClick={() => scrollToSection('home-sacem')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Pourquoi la SACEM</Button>
                <Button size="small" onClick={() => scrollToSection('home-royalties')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Estimateur de royalties</Button>
                <Button size="small" onClick={() => navigate('/contact')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Nous contacter</Button>
              </Box>
            </Grid>

            {/* Legal column */}
            <Grid item xs={6} sm={3}>
              <Typography variant="subtitle2" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 1.5 }}>
                Légal
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Button size="small" onClick={() => navigate('/mentions-legales')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Mentions légales</Button>
                <Button size="small" onClick={() => navigate('/politique-confidentialite')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Politique de confidentialité</Button>
                <Button size="small" onClick={() => navigate('/conditions-utilisation')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Conditions d'utilisation</Button>
                <Button size="small" onClick={() => navigate('/cgv')} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Conditions générales de vente</Button>
              </Box>
            </Grid>

            {/* Social / Contact column */}
            <Grid item xs={6} sm={3}>
              <Typography variant="subtitle2" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 1.5 }}>
                Suivez-nous
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                <Button size="small" component="a" href="https://instagram.com/publymusic" target="_blank" rel="noreferrer" startIcon={<InstagramIcon fontSize="small" />} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>Instagram</Button>
                <Button size="small" component="a" href="mailto:contact@publymusic.fr" startIcon={<EmailOutlinedIcon fontSize="small" />} sx={{ color: colors.textSecondary, justifyContent: 'flex-start', px: 0, textTransform: 'none' }}>contact@publymusic.fr</Button>
              </Box>
            </Grid>
          </Grid>

          {/* Copyright */}
          <Box sx={{ mt: 4, pt: 3, borderTop: `1px solid ${colors.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
            <Typography variant="body2" sx={{ color: colors.textSecondary }}>
              © 2026 PublyMusic. Tous droits réservés.
            </Typography>
            <Typography
              variant="body2"
              sx={{
                background: `linear-gradient(135deg, ${colors.primaryLight}, ${colors.secondary})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontWeight: 700,
                fontSize: '0.9rem',
              }}
            >
              Publy Music
            </Typography>
          </Box>
          </Container>
        </Box>
  );
}

export default memo(HomeFooter);
